import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import WaldofiedFeatureComparison from '../../../../../../components/FreemiumEventPurchase/components/WaldofiedFeatureComparison';
import Button from '../../../../../../../../components/global/Button';
import Angle from '../../../../../../../../components/global/Angle';
import CreateWizardLayout from '../../../../../../components/CreateWizardLayout';
import { breakpointDown } from '../../../../../../../../services/responsive/responsive';
import useIsNativeWebView from '../../../../../../../../services/native-bridge/hooks/useIsWebView';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../../constants/event-items';

const propTypes = {
  eventType: PropTypes.string,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onPrevStep: PropTypes.func.isRequired,
  stepProps: PropTypes.object.isRequired,
  setStepProps: PropTypes.func.isRequired,
};

const VariantB = ({
  values,
  handleChange,
  handleSubmit,
  onPrevStep,
  stepProps,
  setStepProps,
}) => {
  const isMobile = useMediaQuery(breakpointDown('sm'));
  const isNativeWebView = useIsNativeWebView();

  const {
    shouldUseIOSBundles,
    eventAddonItems,
    iOSEventAddonItemsBundle,
    currentSelectedEventAddonItemIds,
    onEventAddonItemToggle,
    eventType,
    waldofiedStepCompleted,
  } = stepProps;

  const waldofiedEventAddonItem = useMemo(
    () =>
      eventAddonItems.find(eventAddonItem =>
        eventAddonItem.types.includes(EVENT_ADDON_ITEM_TYPE.WALDOFIED),
      ),
    [eventAddonItems],
  );

  const completeBundleEventAddonItem = useMemo(
    () =>
      shouldUseIOSBundles
        ? iOSEventAddonItemsBundle
        : eventAddonItems.find(
            item =>
              item.types.includes(EVENT_ADDON_ITEM_TYPE.WALDOFIED) &&
              item.types.includes(EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK) &&
              item.types.includes(EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO),
          ),
    [shouldUseIOSBundles, eventAddonItems],
  );

  return (
    <>
      <WaldofiedFeatureComparison
        waldofiedEventAddonItem={waldofiedEventAddonItem}
        eventType={eventType}
        className="freemium-event-waldofied-step-comparison"
      />
      <CreateWizardLayout.StickyFooter
        className={classNames({
          'waldofied-step-variant-b-footer': true,
          'native-web-view': isNativeWebView,
        })}
      >
        <div className="d-flex mt-2 mt-md-0">
          <Button
            type="button"
            btnStyle="link"
            btnSize={isMobile ? 'sm' : ''}
            onClick={() => {
              onPrevStep(values);
            }}
            className="ml-md-0 mr-md-auto mx-auto text-extra-bold"
          >
            <Angle direction="left" className="mr-1" /> Back
          </Button>
        </div>

        <div className="d-flex justify-content-end">
          <Button
            btnOutline
            btnBlock={isMobile}
            btnSize={isMobile ? 'sm' : ''}
            className=" mr-1"
            onClick={() => {
              if (
                currentSelectedEventAddonItemIds.includes(
                  waldofiedEventAddonItem.id,
                )
              ) {
                onEventAddonItemToggle(waldofiedEventAddonItem.id);
              }

              if (
                currentSelectedEventAddonItemIds.includes(
                  completeBundleEventAddonItem.id,
                )
              ) {
                onEventAddonItemToggle(completeBundleEventAddonItem.id);
                handleChange({
                  target: {
                    name: 'promo_code',
                    value: '',
                  },
                });
              }

              setStepProps(prev => ({
                ...prev,
                waldofiedStepCompleted: true,
              }));
              if (waldofiedStepCompleted) {
                handleSubmit();
              }
            }}
          >
            No, thanks
          </Button>
          <Button
            btnBlock={isMobile}
            className="mt-0"
            btnSize={isMobile ? 'sm' : ''}
            onClick={() => {
              if (
                !currentSelectedEventAddonItemIds.includes(
                  waldofiedEventAddonItem.id,
                ) &&
                !currentSelectedEventAddonItemIds.includes(
                  completeBundleEventAddonItem.id,
                )
              ) {
                onEventAddonItemToggle(waldofiedEventAddonItem.id);
              }

              setStepProps(prev => ({
                ...prev,
                waldofiedStepCompleted: true,
              }));
              handleSubmit();
            }}
            data-testid="album-create-wizard-create-btn"
          >
            Go Gold
          </Button>
        </div>
      </CreateWizardLayout.StickyFooter>
    </>
  );
};

VariantB.propTypes = propTypes;

export default VariantB;
